import { useLocale } from "./useLocale";

/** Keeps <html lang> and <html dir> synced to the active locale app-wide
    (RTL-ready). Renders nothing. */
export function LocaleSync() {
  useLocale();
  return null;
}
